import { Switch, Route, useHistory } from "react-router-dom";
import { AppShell, Container, useMantineColorScheme } from '@mantine/core';
import { useMediaQuery } from "@mantine/hooks";
import { IconSearch, IconCalendar, IconFileInvoice, IconHome, IconReportAnalytics, IconListCheck, IconCheckupList } from "@tabler/icons-react";
import { useMsal } from "@azure/msal-react";
import { pdfjs } from 'react-pdf';

import { NavigationBar, NavigationItem, useNavigationBarState } from "./Components/layout/NavigationBar";
import { HeaderBar } from "./Components/layout/HeaderBar";
import Home from './Pages/Home';
import ViewCalendarPage from "./Pages/Calendar/View";
import ViewCalendarSessionPage from "./Pages/Calendar/Session";
import ViewCheckInPage from "./Pages/CheckIn/View";
import ViewActivityCheckInPage from "./Pages/CheckIn/ActivityView";
import RegistationsHomePage from "./Pages/Registrations/Index";
import NewRegistationPage from "./Pages/Registrations/New";
import ViewRegistationPage from "./Pages/Registrations/View";
import NewFamilyRegistationPage from "./Pages/Registrations/Family/New";
import ReportPage from "./Pages/Reports/View";
import SearchPage from "./Pages/Search/View";

import './App.css';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.js',
  import.meta.url,
).toString();

const App = () => {
	const { instance } = useMsal();
	const account = instance.getActiveAccount();
	const history = useHistory();
	const { colorScheme } = useMantineColorScheme();
	const isMobile = useMediaQuery('(max-width: 48em)');
	
	const { isOpen: navigationOpened, toggle: toggleNavigation } = useNavigationBarState();

	const logoPath = colorScheme === "light" ? `/${import.meta.env.VITE_ICON192}` : `/${import.meta.env.VITE_ICON192_WHITE}`;
	const userName = account?.name;

	const handleSwitchAccount = () => {
		instance.loginRedirect({
			prompt: "select_account",
			scopes: []
		});
	}

	const handleLogout = () => {
		instance.logout({
			// account: account,
			// postLogoutRedirectUri: import.meta.env.VITE_CLIENT_DOMAIN,
			onRedirectNavigate: () => false
		});

		// navigate({ pathname: '/' });
		history.push({ pathname: '/' });
	}

	let navigationItems: NavigationItem[] = [
		{ link: '/', label: 'Home', icon: IconHome },
		{ link: '/calendar', label: 'Enrollment Calendar', icon: IconCalendar },
		{ link: '/registrations', label: 'Registrations', icon: IconFileInvoice },
		{ link: '/check-in', label: 'Program Check In', icon: IconListCheck },
		{ link: '/activity-check-in', label: 'Skills Check In', icon: IconCheckupList },
		{ link: '/reports', label: 'Reports', icon: IconReportAnalytics },
		{ link: '/search', label: 'Search', icon: IconSearch }
	];

	if (import.meta.env.VITE_ENABLE_ACTIVITY_CHECKIN !== "true") {
		navigationItems = navigationItems.filter(item => item.link !== '/activity-check-in');
		let checkInNavigationItem = navigationItems.find(item => item.link === '/check-in');
		if (checkInNavigationItem) {
			checkInNavigationItem.label = 'Check In';
		}
	}

	return (
		<AppShell
			header={{ height: 60 }}
			navbar={{ width: navigationOpened ? 220 : 60, breakpoint: 'sm', collapsed: { mobile: !navigationOpened, desktop: false } }}
			padding="md"
			layout="alt"
			withBorder={true}
		>
			<AppShell.Header withBorder={true}>
				<HeaderBar />
			</AppShell.Header>
			<AppShell.Navbar zIndex={1}>
				<NavigationBar 
					title={import.meta.env.VITE_NAV_TITLE} 
					logoPath={logoPath} 
					items={navigationItems} 
					userName={userName} 
					onSwitchAccount={handleSwitchAccount} 
					onLogout={handleLogout} />
			</AppShell.Navbar>
			<AppShell.Main>
			<Container px={isMobile ? 0 : 'sm'} py={isMobile ? 0 : 'sm'} maw={1200}>
				<Switch>
					<Route path="/" exact component={Home}/>
					<Route path="/calendar" exact component={ViewCalendarPage} />
					<Route path="/calendar/" exact component={ViewCalendarPage} />
					<Route path="/calendar/session/:programSessionId" exact component={ViewCalendarSessionPage} />
					<Route path="/registrations" exact component={RegistationsHomePage} />
					<Route path="/registrations/new" exact component={NewRegistationPage} />
					<Route path="/registrations/view/:registrationId" exact component={ViewRegistationPage} />
					<Route path="/registrations/list/:urlProgramGroup" component={RegistationsHomePage} />
					<Route path="/registrations/family/new" exact component={NewFamilyRegistationPage} />
					<Route path="/check-in" exact component={ViewCheckInPage} />
					<Route path="/activity-check-in" exact component={ViewActivityCheckInPage} />
					<Route path="/reports" exact component={ReportPage} />
					<Route path="/reports/:urlReportKey" component={ReportPage} />
					<Route path="/search" exact component={SearchPage} />
					<Route path="/search/:urlQuery" component={SearchPage} />			
				</Switch>
			</Container>
			</AppShell.Main>
		</AppShell>
	)
}

export default App